import { sendPublicAnalyticsAction } from 'reactApp/modules/public/public.actions';
import { getPublicRootWeblink } from 'reactApp/modules/public/public.selectors';
import { store as reduxStore } from 'reactApp/store';
import { openComplain } from 'reactApp/utils/openComplain';
import { EPaymentGa } from 'reactApp/utils/paymentGa';

export const sendComplain = () => {
    const id = getPublicRootWeblink(reduxStore.getState())?.weblink;

    reduxStore.dispatch(
        sendPublicAnalyticsAction({
            id,
            action: EPaymentGa.seoComplaint,
        })
    );
    openComplain();
};
